import currencyFormatter from '~/utils/currencyFormatter';

export function fmtPct(v: number | null | undefined, digits = 1): string {
  if (v == null || !Number.isFinite(v)) {
    return '—';
  }
  return `${(v * 100).toFixed(digits)}%`;
}

export function fmtSignedPct(v: number | null | undefined, digits = 1): string {
  if (v == null || !Number.isFinite(v)) {
    return '—';
  }
  const pct = v * 100;
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toFixed(digits)}%`;
}

export function fmtInt(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) {
    return '—';
  }
  return Math.round(v).toLocaleString();
}

export function fmtAud(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) {
    return '—';
  }
  return currencyFormatter('AUD', v, 0);
}

export function fmtShortDate(iso: string): string {
  if (!iso) {
    return '';
  }
  // `new Date('YYYY-MM-DD')` parses as UTC midnight, which renders one day
  // earlier in negative-offset timezones. Parse the calendar date directly.
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!match) {
    return iso;
  }
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const day = Number(match[3]);
  const date = new Date(year, monthIndex, day);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
